export { default as ProductsIndexPageHeader } from './ProductsIndexPageHeader';
